module.exports = __webpack_public_path__ + "static/media/icon-staging.745dce57.png";